module.exports = __webpack_public_path__ + "img/35ne.93e08d80.svg";